import { useBloc } from "@blac/react";
import { useId } from "react";
import FileUploadCubit, { FileUploadConfig } from "./FileUploadCubit";

const useFileUploadState = (options: FileUploadConfig = {}) => {
  const instanceId = useId();
  const [state, cubit] = useBloc(FileUploadCubit, { id: instanceId });
  cubit.setConfig(options);

  return {
    instanceId,
    files: state.files,
    fileErrors: state.fileErrors,
    fileStatuses: state.fileStatuses
  };
};

export default useFileUploadState;
